import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { distinctUntilChanged, takeUntil } from 'rxjs';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { InfoTooltipComponent } from '../info-tooltip.component';
import { UserStore } from 'app/core/services/user.store';
import { } from '@angular/common';
import { calculateLeaveHours } from './date-hours-calculator.utils';

@Component({
  selector: 'formly-field-date-hours-calculator',
  template: `
    <div>
      <h3 class="mb-2">
        {{ props.label }}
        <app-info-tooltip [tooltip]="props.info"></app-info-tooltip>
      </h3>
      <div class="block">
        @for (field of field.fieldGroup; track $index) {
          <formly-field [field]="field" [class]="field.className"></formly-field>
        }
      </div>
      @if (field.props.description) {
        <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormlyModule, MatInputModule, MatDatepickerModule, InfoTooltipComponent],
})
export class FormlyFieldDateHoursCalculator extends FieldType<FieldTypeConfig> implements OnInit {
  userStore = inject(UserStore);
  private destroy$ = injectDestroy();

  constructor() {
    super();
  }

  ngOnInit() {
    this.field.formControl.valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe(() => {
      const hours = this.field.formControl.get('hours');
      if (!hours) {
        return;
      }

      const startDate = this.field.formControl.get('startDate')?.value;
      const endDate = this.field.formControl.get('endDate')?.value;

      if (!startDate || !endDate) {
        return;
      }

      hours.patchValue(calculateLeaveHours(startDate, endDate), { emitEvent: false });
    });
  }
}
